import React, { useContext } from "react";
import { IonButton } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import FlavoriaPage from "../components/FlavoriaPage";
import MyFlavoriaLogo from "../assets/my_flavoria_logo_white.png";
import i18n from "../i18n";
import NewsCards from "../components/NewsCards";
import LunchCards from "../components/LunchCards";
import GlobalContext from "../GlobalContext";
import { ResearchType } from "../pages/loginPages/ConsentFormPage";
import { rootPath } from "../Utils";
import { isInstalledApp } from "../platform/abstraction";
import { showAddToHomeScreen } from "../utils/addToHomeScreen";

interface Props {
  onLoginRequest: () => void;
}

const Home: React.FC<Props> = ({ onLoginRequest }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const context = useContext(GlobalContext);
  const loggedIn =
    context.agreementAccepted &&
    context.wannaParticipate &&
    context.acceptedResearchType !== ResearchType.NONE;
  const installed = isInstalledApp();

  return (
    <FlavoriaPage className="home" pageID={"ACTIVE_PAGE_HOME"}>
      <>
        {!installed && (
          <center style={{ padding: "20px" }}>
            <IonButton
              expand="block"
              color="primary"
              onClick={() => showAddToHomeScreen()}
            >
              {t("Install the App")}
            </IonButton>
          </center>
        )}
        {!loggedIn && (
          <center style={{ padding: "20px" }}>
            <IonButton expand="block" color="secondary" onClick={onLoginRequest}>
              {t("Login")}
            </IonButton>
          </center>
        )}
        <LunchCards language={i18n.language} />
        <NewsCards language={i18n.language} />
      </>

      <center style={{ padding: "30px" }}>
        <img width="250" src={MyFlavoriaLogo}></img>
        <br /><br />
        <a href="https://flavoria.fi" target="_blank" rel="noopener noreferrer">flavoria.fi</a> 
        <span> - </span><a href="https://www.facebook.com/utuflavoria" target="_blank" rel="noopener noreferrer" >Facebook</a> 
        <span> - </span> <a href="https://www.youtube.com/@flavoria-tutkimusalusta6501" target="_blank" rel="noopener noreferrer">YouTube</a>
        <div style={{ display: "flex", justifyContent: "center", gap: "8px", padding: "16px" }}>
          <IonButton fill="solid" onClick={() => history.push(`${rootPath}/grillqueue`)}>
            {t("Grill Queue")}
          </IonButton>
        </div>
      </center>
    </FlavoriaPage>
  );
};

export default Home;
